module.exports = require("npm:desandro-matches-selector@2.0.2/matches-selector.js");